export enum StatusTypes {
  OFFLINE = 0,
  AWAY = 1,
  AVAILABLE = 2
}
